import React, { Children } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { H2 } from 'components/core/Typography';
import { Section, Group } from 'components/core/Page';
import Link from 'components/core/Link/Link';

import './drillDownLinks.scss';

export function DrillDownLinks({ headline, links }) {
	if (isEmpty(links)) return null;
	return (
		<Section>
			<Group>
				<H2 size="medium">
					{headline}
				</H2>
			</Group>
			<ul className="content-links">
				{Children.toArray(links.map((link) => (
					<li
						className="content-link-item"
					><Link class="js-drilldownlinkselector" href={link.href} >{link.text}</Link></li>
				)))}
			</ul>
		</Section>

	);
}

DrillDownLinks.propTypes = {
	headline: PropTypes.string.isRequired,
	links: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string,
			html: PropTypes.string,
			uri: PropTypes.string,
			href: PropTypes.string
		})
	).isRequired
};


export default DrillDownLinks;
